import axios from 'axios';
import VueScrollTo from 'vue-scrollto';

export default {
  directives: {
    VueScrollTo,
  },

  props: {
    min: {
      type: Number,
      default: 50,
    },
    wpNonce: {
      type: String,
      default: null,
    },
    postId: {
      type: Number,
      required: true,
    },
    wpAjax: {
      type: String,
      default: '/wp-admin/admin-ajax.php',
    },
    amounts: {
      type: Array,
      default: () => [],
    },
    defaultAmount: {
      type: Number,
      default: null,
    },
    background: {
      type: String,
      default: null,
    },
    imagePosition: {
      type: Boolean,
      default: false,
    },
    getAddressFromSocialSecurity: {
      type: Boolean,
      default: true,
    },
    isCompany: {
      type: Boolean,
      default: false,
    },
    banks: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Donation form',
    },
    subtitle: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    labels: {
      type: Object,
      default: () => {},
      required: true,
    },
    errorPositionTop: {
      type: Boolean,
      default: false,
    },
    leadId: {
      type: Number,
      default: null,
    },
    hideAddress: {
      type: Boolean,
      default: true,
    },
    showCurrency: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: ' kr',
    },
    facebook: {
      type: Object,
      default: () => {
        return {
          active: false,
          lead: null,
          checkout: null,
          purchase: null,
        };
      },
    },
    gdpr: {
      type: String,
      default: null,
    },
    stripeKey: {
      type: String,
      default: null,
    },
    pledgeTargets: {
      type: [Boolean, Array, Object],
      default: false,
    },
    campaignId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      qr: null,
      autoStartToken: null,
      showQr: false,
      showBankIdMessage: false,
      usingSameDevice: false,
      form: {
        socialSecurityNumber: null,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        phone2: null,
        address: null,
        address2: null,
        zip: null,
        city: null,
        company: null,
        amount: null,
        method: null,
        bankClearing: null,
        bankAccount: null,
        bank: 0,
        paymentType: null,
        leadId: null,
        anonym: false,
        pledgeTarget: null,
        productType: null,
      },
      bankAccountRetrieval: {
        status: false,
        token: null,
        interval: null,
        timeout: null,
        message: null,
        accounts: [],
        selected: false,
      },
      bankIdSignature: {
        status: false,
        token: null,
        interval: null,
        timeout: null,
        message: null,
      },
      bankIdModal: false,
      bankAccountModal: false,
      paymentId: null,
      addressRetrievalInProgress: false,
      payexRedirectInProgress: false,
      submitDisabled: false,
      maskAddress: false,
      manualFill: false,
      addressRetrieved: false,
      step: null,
      error: null,
      showTerms: false,
      defaultTerms:
        'When you go to Payment, you agree that we save your personal information as you provided in the form for 36 months after your last gift.<br />We save your personal information to feedback to you how your gifts make a difference. To keep updated information about you, we will use our social security number.<br />You are entitled to rectify your information at any time or to be completely removed from our registry. Then contact us. If you believe that we have processed your personal information incorrectly, you may contact the Data Inspectorate. <br /><a href="#">Here</a> you can read our entire privacy policy',
      defaultValidation: {
        email:
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        phone: /^(\+|00|0)[\d\+\- ]{6,}$/,
        zip: /^[\d -]+$/,
        firstName: /^[a-zA-ZåäöÅÄÖéèÈÉÛûüÜ -]{2,}$/,
        lastName: /^[a-zA-ZåäöÅÄÖéèÈÉÛûüÜ -]{2,}$/,
        bankClearing: /^[\d ,-]+$/,
        bankAccount: /^[\d ,-]+$/,
        address: /(?!^\d+$)^.+$/,
        city: /(?!^\d+$)^.+$/,
        socialSecurityNumber: /^[0-9]{8}[- ]?[0-9]{4}$/,
        recipient_firstName: /^[a-zA-ZåäöÅÄÖéèÈÉÛûüÜ -]{2,}$/,
        recipient_lastName: /^[a-zA-ZåäöÅÄÖéèÈÉÛûüÜ -]{2,}$/,
        recipient_address: /(?!^\d+$)^.+$/,
        recipient_zip: /^[\d -]+$/,
        recipient_city: /(?!^\d+$)^.+$/,
        recipient_email:
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      },
      message: null,
      amount: null,
      prefilled: null,
      formName: null,
      previewLink: null,
      showStripe: false,
      showSwish: false,
    };
  },

  watch: {
    form: {
      handler: function (value) {
        if (value.method !== 'stripe') {
          this.showStripe = false;
        }
      },
      deep: true,
    },
    error: function (value, oldValue) {
      if (oldValue === null && value !== null) {
        this.$scrollTo('#anchor', 500, { offset: -100 });
      }
    },
    message: function (value, oldValue) {
      if (oldValue === null && value !== null) {
        this.$scrollTo('#anchor', 500, { offset: -100 });
      }
    },
    bankAccountRetrieval: {
      handler: function (value) {
        switch (value.status) {
          case false:
            this.bankAccountRetrieval.message = this.labels.getBankAccount;
            break;
          case 'Starting':
            this.bankAccountRetrieval.message = this.labels.bankIdWait;
            break;
          case 'Waiting':
            this.bankAccountRetrieval.message = this.labels.bankIdOpen;
            break;
          case 'Aborted':
            clearTimeout(this.bankAccountRetrieval.timeout);
            clearInterval(this.bankAccountRetrieval.interval);
            break;
          case 'Failed':
            clearTimeout(this.bankAccountRetrieval.timeout);
            clearInterval(this.bankAccountRetrieval.interval);
            this.error = this.labels.errorGetBank;
            break;
          case 'Success':
            clearTimeout(this.bankAccountRetrieval.timeout);
            clearInterval(this.bankAccountRetrieval.interval);
            break;
        }
      },
      deep: true,
    },

    bankIdSignature: {
      handler: function (value) {
        switch (value.status) {
          case false:
            this.bankIdSignature.message = this.labels.submit;
            break;
          case 'Started':
          case 'OutstandingTransaction':
            this.bankIdSignature.message = this.labels.bankIdOpen;
            break;
          case 'Aborted':
            clearTimeout(this.bankIdSignature.timeout);
            clearInterval(this.bankIdSignature.interval);
            this.bankIdSignature.status = false;
            break;
          case 'Error':
            clearTimeout(this.bankIdSignature.timeout);
            clearInterval(this.bankIdSignature.interval);
            this.bankIdSignature.status = false;
            this.error = this.labels.errorSignature;
            break;
          case 'NoClient':
            clearTimeout(this.bankIdSignature.timeout);
            clearInterval(this.bankIdSignature.interval);
            this.bankIdSignature.status = false;
            this.error = this.labels.errorNoClient;
            break;
          case 'Complete':
            clearTimeout(this.bankIdSignature.timeout);
            clearInterval(this.bankIdSignature.interval);
            this.bankIdSignature.status = false;
            break;
        }
      },
      deep: true,
    },
  },

  filters: {
    preview: function (value, length) {
      if (!value) return false;
      if (value.replace(/<\/?[^>]+(>|$)/g, '').length < length) return value;
      let subString = value.substr(0, length - 1);
      return subString.substr(0, subString.lastIndexOf(' ')) + '&hellip;';
    },

    stripTags: function (value) {
      return value.replace(/<\/?[^>]+(>|$)/g, '');
    },

    thousandsSeparator: function (value) {
      return parseInt(value).toLocaleString('en').replace(/,/g, ' ');
    },

    currency: function (value, showCurrency, currency) {
      if (showCurrency === true && currency !== false) {
        return value + currency;
      }
      return value;
    },
  },

  mounted() {
    if (this.defaultAmount && this.amounts.indexOf(this.defaultAmount) > -1) {
      this.prefilled = parseInt(this.defaultAmount);
    }
    if (this.leadId !== null) {
      this.getLead();
    }
  },

  computed: {
    addressLabel() {
      return this.addressRetrieved === true
        ? this.labels.emptyAddress
        : this.labels.getAddress;
    },

    fullName() {
      return this.isCompany
        ? this.form.company
        : `${this.form.firstName} ${this.form.lastName}`;
    },

    isMobile() {
      return /FBAN|FBAV|Instagram|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        // eslint-disable-next-line
        navigator.userAgent,
      );
    },

    bankIdText() {
      return this.labels.bankIdText;
    },

    bankIdHeader() {
      return this.labels.bankIdHeader;
    },

    bankAccountHeader() {
      return this.labels.bankAccountHeader;
    },

    bankAccountText() {
      return this.labels.bankAccountText;
    },

    qrBankText() {
      return this.labels.qrBankText;
    },
  },

  methods: {
    isValid(key) {
      if (this.form[key] === null || this.form[key] === '') return false;
      if (key === 'amount') {
        if (this.amount === null && this.form.amount)
          this.amount = this.form.amount;
        return (
          !isNaN(this.amount) &&
          this.amount !== null &&
          parseInt(this.amount) >= this.min
        );
      }
      let expr = this.validationRegExpr[key];
      return expr ? expr.test(this.form[key]) : true;
    },

    checkValidation(e) {
      switch (e) {
        case 'deceased_name':
          this.validDeceasedName = true;
          break;
        case 'pledgeTarget':
          this.validPledge = true;
          break;
        case 'email':
          this.validEmail = true;
          break;
        case 'phone':
          this.validPhone = true;
          break;
        case 'socialSecurityNumber':
          this.validSsn = true;
          break;
        case 'socialsecuritynumber':
          this.validSsn = true;
          break;
        case 'firstname':
          this.validName = true;
          break;
        case 'lastname':
          this.validSurname = true;
          break;
        case 'address':
          this.validAdress = true;
          break;
        case 'zip':
          this.validZip = true;
          break;
        case 'city':
          this.validCity = true;
          break;
        case 'clearing':
          this.validClearing = true;
          break;
        case 'account':
          this.validAccount = true;
          break;
        case 'recipient_firstName':
          this.validRecipientName = true;
          break;
        case 'recipient_lastName':
          this.validRecipientSurname = true;
          break;
        case 'recipient_address':
          this.validRecipientAdress = true;
          break;
        case 'recipient_zip':
          this.validRecipientZip = true;
          break;
        case 'recipient_city':
          this.validRecipientCity = true;
          break;
        case 'recipient_email':
          this.validRecipientEmail = true;
          break;
        default:
          break;
      }
    },

    areValid(keys) {
      for (let k in keys) {
        if (this.isValid(keys[k]) == false) return false;
      }
      return true;
    },

    getOrEmptyAddress() {
      return this.addressRetrieved === true
        ? this.emptyAddress()
        : this.getAddress();
    },

    emptyAddress() {
      this.maskAddress = false;
      this.form.firstName = null;
      this.form.lastName = null;
      this.form.address2 = null;
      this.form.address = null;
      this.form.zip = null;
      this.form.city = null;
      this.addressRetrieved = false;
    },

    getAddress() {
      this.form.socialSecurityNumber = this.formatSSN(
        // eslint-disable-next-line
        this.form.socialSecurityNumber,
      );
      this.addressRetrieved = false;
      if (
        this.form.socialSecurityNumber === null ||
        !this.isValid('socialSecurityNumber')
      ) {
        this.error = this.labels.errorSSN;
        return false;
      }
      this.addressRetrievalInProgress = true;
      this.error = null;
      let data = this.getFormData({
        ssn: this.form.socialSecurityNumber,
        action: 'get_address',
      });
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          this.addressRetrievalInProgress = false;
          if (response.data.GivenName || response.data.LastName) {
            this.maskAddress = true;
            this.form.firstName =
              response.data.GivenName !== ''
                ? response.data.GivenName
                : response.data.FirstName;
            this.form.lastName = response.data.LastName;
            this.form.address2 = response.data.CoAddress;
            this.form.address = response.data.Address;
            this.form.zip = response.data.Zipcode;
            this.form.city = response.data.City;
            this.addressRetrieved = true;
            if (this.form.leadId !== null) {
              this.saveLead();
            }
          }
        })
        .catch(() => {
          this.addressRetrievalInProgress = false;
          this.error = this.labels.errorGetAddress;
        });
    },

    fillSelf() {
      this.maskAddress = false;
      this.manualFill = true;
    },

    getBankAccount() {
      this.form.socialSecurityNumber = this.formatSSN(
        // eslint-disable-next-line
        this.form.socialSecurityNumber,
      );
      if (
        this.form.socialSecurityNumber === null ||
        !this.isValid('socialSecurityNumber')
      ) {
        this.error = this.labels.errorSSN;
        return false;
      }
      this.bankAccountRetrieval.status = 'Starting';
      this.error = null;
      this.autoStartToken = null;
      let data = this.getFormData({
        leadId: this.form.leadId,
        action: 'get_bank',
        bank: this.form.bank,
        socialsecuritynumber: this.form.socialSecurityNumber,
        anotherDevice: this.showQr,
      });
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response.data && response.data.PublicId) {
            this.bankAccountRetrieval.token = response.data.PublicId;
            let self = this;
            this.bankAccountRetrieval.interval = setInterval(function () {
              self.pollBankAccount(self.bankAccountRetrieval.token);
            }, 1000);
            this.bankAccountRetrieval.timeout = setTimeout(function () {
              if (self.bankAccountRetrieval.interval !== null) {
                self.bankAccountRetrieval.status = 'Aborted';
              }
            }, 120000);
          } else {
            this.bankAccountRetrieval.status = false;
          }
        })
        .catch(() => {
          this.bankAccountRetrieval.status = false;
          this.error = this.labels.errorGetBank;
          this.bankAccountModal = false;
        });
    },

    anotherDeviceQr() {
      this.showQr = true;
      this.getBankAccount();
    },

    sameDeviceQr() {
      this.showQr = false;
      this.getBankAccount();
    },

    autoStart() {
      window.location = `https://app.bankid.com?autostarttoken=${this.autoStartToken}&redirect=null`;
    },

    pollBankAccount(token) {
      let data = this.getFormData({
        leadId: this.form.leadId,
        action: 'bank_id_bank_account',
        token: token,
      });
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          console.log(response.data.status);
          if (response && response.data && response.data.status) {
            if (
              response.data.BankIdAutostartToken &&
              this.showQr === false &&
              this.autoStartToken === null
            ) {
              this.autoStartToken = response.data.BankIdAutostartToken;
              window.location = `https://app.bankid.com?autostarttoken=${response.data.BankIdAutostartToken}&redirect=null`;
            }
            if (response.data.status === 'Waiting') {
              this.qr = response.data.qr;
            }
            if (response.data.status === 'Success') {
              this.qr = null;
              this.autoStartToken = null;
              this.showQr = false;
              this.bankAccountRetrieval.accounts = response.data.accounts;
              this.bankAccountRetrieval.selected = false;
            }
            this.bankAccountRetrieval.status = response.data.status;
          }
        })
        .catch(() => {
          this.qr = null;
          this.showQr = false;
          this.autoStartToken = null;
          this.bankAccountRetrieval.status = false;
          this.error = this.labels.errorGetBank;
        });
    },

    pollBankId(token) {
      let data = this.getFormData({
        leadId: this.form.leadId,
        action: 'bank_id_sign',
        token: token,
      });
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response && response.data && response.data.status) {
            this.bankIdSignature.status = response.data.status;
            this.qr = response.data.QR;
            if (response.data.status === 'Complete') {
              window.location = response.data.url
                ? response.data.url
                : this.returnUrl + '?id=' + this.form.leadId;
            }
          }
        })
        .catch(() => {
          this.bankIdSignature.status = false;
          this.error = this.labels.errorSignature;
        });
    },

    anonymizeForm() {
      for (let key in this.form) {
        if (
          key !== 'anonym' &&
          key !== 'method' &&
          key !== 'pledgeTarget' &&
          key !== 'template' &&
          key !== 'amount' &&
          key !== 'leadId'
        ) {
          this.form[key] = 'XXXXX';
        }
      }
    },

    getPaymentData() {
      if (this.form.anonym === true) {
        this.anonymizeForm();
      }
      let fields = {
        leadId: this.form.leadId,
        firstname: this.form.firstName,
        lastname: this.form.lastName,
        address: this.form.address,
        address2: this.form.address2,
        zip: this.form.zip,
        city: this.form.city,
        action: 'initiate_payment',
        amount: this.form.amount,
        socialsecuritynumber: this.form.socialSecurityNumber,
        company: this.form.company,
        email: this.form.email,
        phone: this.form.phone,
        phone2: this.form.phone2,
        text: this.formName,
        template: this.form.template,
        method: this.form.method,
        returnUrl: this.returnUrl,
        cancelUrl: window.location.href,
        formId: this.postId,
        isAnonym: this.form.anonym ? 1 : 0,
        isCompany: this.isCompany ? 1 : 0,
        pledgeTarget: this.form.pledgeTarget,
        campaignId: this.campaignId,
        collection: this.collection ? this.collection.title : null,
        collectionId: this.collection ? this.collection.id : null,
        author: this.collection ? this.collection.author : null,
        productType: this.productType,
      };
      if (['tribute', 'memorial', 'shop'].indexOf(this.form.template) > -1) {
        let extra = {
          recipient_email: this.form.recipient_email,
          recipient_firstName: this.form.recipient_firstName,
          recipient_lastName: this.form.recipient_lastName,
          recipient_address: this.form.recipient_address,
          recipient_zip: this.form.recipient_zip,
          recipient_city: this.form.recipient_city,
          card: JSON.stringify(this.form.card),
          send_via: this.form.send_via,
          send_to: this.form.send_to,
          card_text: this.form.card_text,
          deceased_name: this.form.deceased_name,
        };
        // jshint ignore:start
        fields = { ...fields, ...extra };
        // jshint ignore:end
      }
      if (this.form.template === 'shop') {
        fields.cart = JSON.stringify(this.cart);
      }
      if (this.form.template === 'memorial') {
        try {
          let d = new Date(this.form.burialDate);
          let offset = d.getTimezoneOffset();
          d = new Date(d.getTime() + offset * 60 * 1000);
          fields.burialDate = d.toISOString().split('T')[0];
        } catch (e) {
          console.log('invalid date');
          fields.burialDate = this.form.burialDate;
        }
      }
      return this.getFormData(fields);
    },

    swish() {
      if (!this.isValid('phone')) {
        this.error = this.labels.errorPhone;
        return false;
      }
      if (this.form.amount === null) {
        this.error = this.labelsNoAmount;
        return false;
      }
      if (this.pledgeTargets && this.form.pledgeTarget === null) {
        this.checkValidation('pledgeTarget');
        this.error = this.labels.errorRequiredFields;
        return false;
      }
      this.submitDisabled = true;
      const data = this.getPaymentData();
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response.data.paymentRequest) {
            this.showSwish = true;
            this.paymentId = response.data.paymentRequest;
            if (this.form.leadId === null) {
              this.form.leadId = response.data.id;
              this.facebookTrack('checkout');
            }
          } else {
            this.error =
              response.data.error && response.data.code
                ? this.labels[response.data.code]
                : this.labels.error;
            this.submitDisabled = false;
          }
        })
        .catch(() => {
          this.submitDisabled = false;
        });
    },

    initiateStripe() {
      const data = this.getPaymentData();
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response.data.id) {
            if (this.form.leadId === null) {
              this.form.leadId = response.data.id;
            }
            this.facebookTrack('checkout');
          }
        })
        .catch();
    },

    finishStripe(payload) {
      const data = this.getFormData({
        action: 'stripe_completed',
        status: payload.status,
        reference: payload.reference,
        leadId: this.form.leadId,
      });
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response.data.status === 'Completed') {
            window.location = this.returnUrl;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    payex() {
      const mandatoryFields = [
        'firstName',
        'lastName',
        'address',
        'zip',
        'city',
        'phone',
        'email',
      ];
      if (this.isCompany) {
        mandatoryFields.push('socialSecurityNumber');
      }
      if (this.form.anonym === false && this.missingFields(mandatoryFields)) {
        return false;
      }
      if (this.pledgeTargets && this.form.pledgeTarget === null) {
        this.checkValidation('pledgeTarget');
        this.error = this.labels.errorRequiredFields;
        return false;
      }
      this.payexRedirectInProgress = true;
      const data = this.getPaymentData();
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response.data && response.data.href) {
            this.facebookTrack('checkout');
            window.location = response.data.href;
          } else {
            this.payexRedirectInProgress = false;
            this.error =
              response.data.error && response.data.code
                ? this.labels[response.data.code]
                : this.labels.errorPayex;
          }
        })
        .catch(() => {
          this.payexRedirectInProgress = false;
          this.error = this.labels.errorPayex;
        });
    },

    autogiro(isYearly) {
      if (this.form.anonym === true) {
        this.error = this.labels.error;
        return false;
      }
      if (this.pledgeTargets && this.form.pledgeTarget === null) {
        this.checkValidation('pledgeTarget');
        this.error = this.labels.errorRequiredFields;
        return false;
      }
      if (
        this.form.bankClearing === null ||
        this.form.bankAccount === null ||
        this.form.bank === null
      ) {
        this.error = this.labels.errorBankAccount;
        return false;
      }
      this.form.socialSecurityNumber = this.formatSSN(
        // eslint-disable-next-line
        this.form.socialSecurityNumber,
      );
      if (
        this.form.socialSecurityNumber === null ||
        !this.isValid('socialSecurityNumber')
      ) {
        this.error = this.labels.errorSSN;
        return false;
      }
      if (
        this.missingFields([
          'firstName',
          'lastName',
          'address',
          'zip',
          'city',
          'phone',
          'email',
          'bankAccount',
          'bankClearing',
          'amount',
          'socialsecuritynumber',
        ])
      ) {
        return false;
      }
      this.bankIdSignature.status = 'Waiting';
      let data = this.getFormData({
        leadId: this.form.leadId,
        firstname: this.form.firstName,
        lastname: this.form.lastName,
        address: this.form.address,
        address2: this.form.address2,
        zip: this.form.zip,
        city: this.form.city,
        phone: this.form.phone,
        phone2: this.form.phone2,
        email: this.form.email,
        bank: this.form.bank,
        text: this.formName,
        account: this.form.bankAccount,
        clearing: this.form.bankClearing,
        amount: this.form.amount,
        socialsecuritynumber: this.form.socialSecurityNumber,
        company: this.form.company,
        action: 'initiate_signature',
        formId: this.postId,
        isYearly: isYearly ? 1 : 0,
        template: this.form.template,
        returnUrl: this.returnUrl,
        pledgeTarget: this.form.pledgeTarget,
        campaignId: this.campaignId,
        productType: this.productType,
      });
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response.data && response.data.Status === 'Started') {
            if (response.data.AutoStartToken) {
              this.autoStartToken = response.data.AutoStartToken;
            }
            this.facebookTrack('checkout');
            this.showBankIdMessage = false;
            this.bankIdSignature.token = response.data.ReferenceToken;
            this.bankIdSignature.status = response.data.Status;
            let self = this;
            this.bankIdSignature.interval = setInterval(function () {
              self.pollBankId(self.bankIdSignature.token);
            }, 1000);
            this.bankIdSignature.timeout = setTimeout(function () {
              if (self.bankIdSignature.interval !== null) {
                self.bankIdSignature.status = 'Aborted';
              }
            }, 120000);
            if (this.usingSameDevice === true) {
              window.location = `https://app.bankid.com?autostarttoken=${this.autoStartToken}&redirect=null`;
            } else {
              this.qr = response.data.QR;
              this.showBankIdMessage = true;
            }
          } else {
            this.closeBankIdModal();
            if (response.data.error && response.data.code) {
              this.error = this.labels[response.data.code];
            } else if (response.data.error && response.data.message) {
              try {
                const msg = JSON.parse(response.data.message);
                this.error = msg.Message;
              } catch (e) {
                this.error = 'An error occured';
              }
            }
            this.bankIdSignature.status = false;
          }
        })
        .catch(() => {
          this.bankIdSignature.status = false;
          this.error = this.labels.errorSignature;
        });
    },

    yearlyAutogiro() {
      return this.autogiro(true);
    },

    formatSSN(ssn) {
      if (ssn === null) return null;
      let ret = ssn.replace(/\D/, '');
      if (ret.length === 12) return ret;
      else if (ret.length === 10 && parseInt(ret.substring(0, 2)) < 25) {
        return '20' + ret;
      } else if (ret.length === 10) {
        return '19' + ret;
      }
      return null;
    },

    saveLead() {
      let data = this.getFormData({
        phone: this.form.phone,
        phone2: this.form.phone2,
        email: this.form.email,
        leadId: this.form.leadId,
        firstname: this.form.firstName,
        lastname: this.form.lastName,
        address: this.form.address,
        address2: this.form.address2,
        text: this.formName,
        zip: this.form.zip,
        city: this.form.city,
        bank: this.form.bank !== 0 ? this.form.bank : null,
        account: this.form.bankAccount,
        clearing: this.form.bankClearing,
        amount: this.form.amount,
        socialsecuritynumber: this.form.socialSecurityNumber,
        company: this.form.company,
        method: this.form.method,
        url: window.location.href,
        action: 'save',
        formId: this.postId,
        template: this.form.template,
        pledgeTarget: this.form.pledgeTarget,
        campaignId: this.campaignId,
        productType: this.productType,
      });
      if (this.form.template === 'shop') {
        data.append('cart', JSON.stringify(this.cart));
      }
      if (this.form.leadId === null) {
        this.facebookTrack('lead');
      }
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response.data.id && this.form.leadId === null) {
            this.form.leadId = response.data.id;
          }
        })
        .catch();
    },

    missingFields(fields) {
      this.error = null;
      let errors = [];
      fields.map((field) => {
        if (
          this.form[field] === '' ||
          this.form[field] === null ||
          !this.isValid(field)
        ) {
          errors.push(field);
        }
      });
      if (errors.length) {
        this.error = this.labels.errorRequiredFields;
        return errors;
      }
      return false;
    },

    toggleTerms() {
      this.showTerms = !this.showTerms;
    },

    getFormData(obj) {
      let formData = new FormData();
      for (let k in obj) {
        if (obj[k] !== null) {
          formData.append(k, obj[k]);
        }
      }
      formData.append('nonce', this.wpNonce);
      return formData;
    },

    getLead() {
      let data = this.getFormData({
        leadId: this.leadId,
        action: 'get',
      });
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          if (response.data) {
            let lead = response.data.lead;
            for (let key in lead) {
              if (this.form.hasOwnProperty(key)) {
                this.form[key] = lead[key];
              } else {
                if (
                  this.form.hasOwnProperty('firstName') &&
                  key === 'firstname'
                ) {
                  this.form.firstName = lead.firstname;
                }
                if (
                  this.form.hasOwnProperty('lastName') &&
                  key === 'lastname'
                ) {
                  this.form.lastName = lead.lastname;
                }
                if (
                  this.form.hasOwnProperty('bankAccount') &&
                  key === 'account'
                ) {
                  this.form.bankAccount = lead.account;
                }
                if (
                  this.form.hasOwnProperty('bankClearing') &&
                  key === 'clearing'
                ) {
                  this.form.bankClearing = lead.clearing;
                }
              }
            }
            this.form.leadId = lead.ID;
            if (lead.amount) {
              let amount = parseInt(lead.amount);
              if (this.amounts.indexOf(amount) > -1) {
                this.prefilled = amount;
              } else {
                this.prefilled = null;
                this.amount = amount;
              }
            }
          }
        })
        .catch();
    },

    facebookTrack(event) {
      if (
        this.facebook.active === true &&
        this.facebook[event] !== null &&
        window.fbq
      ) {
        window.fbq('track', this.facebook[event]);
      }
    },

    slugify(string) {
      return string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },

    saveUncompletedLead() {
      /* do not remove */
    },

    getPreviewLink(cardData, customerData) {
      this.previewLink = null;
      let data = this.getFormData({
        action: 'preview',
        card: cardData.id,
        x: cardData.x,
        y: cardData.y,
        card_width: cardData.card_width,
        negative: cardData.negative,
        first_line: cardData.first_line,
        second_line: cardData.second_line,
        text: customerData.text ? customerData.text : null,
        target: this.selectedTarget,
      });
      axios
        .post(this.wpAjax, data)
        .then((res) => {
          if (res.data.url) {
            const zoom = this.isMobile ? 30 : 50;
            this.previewLink = `${res.data.url}#zoom=${zoom}&toolbar=0`;
          }
          this.previewLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.previewLoading = false;
        });
    },

    closeSwish(success) {
      this.submitDisabled = false;
      this.showSwish = false;
      if (success) {
        window.location = this.returnUrl;
      }
    },

    startBankIdSign(isYearly = false) {
      this.autoStartToken = null;
      this.qr = null;
      this.usingSameDevice = this.isMobile;
      this.autogiro(isYearly);
      return this.isMobile ? null : this.openBankIdModal();
    },

    openBankIdModal() {
      this.bankIdModal = true;
    },

    closeBankIdModal() {
      clearTimeout(this.bankIdSignature.timeout);
      clearInterval(this.bankIdSignature.interval);
      this.bankIdModal = false;
    },

    openBankAccountModal() {
      this.error = null;
      this.bankAccountModal = true;
    },

    closeBankAccountModal() {
      clearTimeout(this.bankAccountRetrieval.timeout);
      clearInterval(this.bankAccountRetrieval.interval);
      this.bankAccountRetrieval.status = false;
      this.bankAccountModal = false;
      this.bankAccountRetrieval.status = false;
    },
  },
};
